import React, { useContext, useEffect, useState } from 'react';
import SettingsIcon from '@material-ui/icons/Settings';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import './style.scss';
import { Context } from '../../store';
import CustomDialog from '../dialog';

const Settings = ({ props }) => {
  const { state, dispatch } = useContext(Context);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const onSubmit = () => {
    dispatch({ type: 'USER_LOGOUT' });
    props.history.push('/login');
  };
  const Options = [
    {
      icon: (
        <img
          src={state.userImg}
          alt='userimage'
          style={{
            width: '24px',
            height: '24px',
            borderRadius: '50%',
          }}
        />
      ),
      name: 'Profile',
      func: () => {
        props.history.push(`/profile/${state.token}`);
      },
    },
    {
      icon: <SettingsIcon />,
      name: 'Settings',
      func: () => {
        props.history.push('/settings');
      },
    },
    {
      icon: <ArrowForwardIosIcon />,
      name: 'Logout',
      func: () => setOpen(true),
    },
  ];
  useEffect(() => {
    if (state.logged) {
      const cai = document.getElementById('cai').style;
      const global = document.getElementById('global').style;

      if (props.match.path === '/main') cai.backgroundColor = '#111';
      if (props.match.path === '/global') global.backgroundColor = '#111';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className='settings'>
      {state.logged ? (
        <>
          <div className='settings-profile'>
            <div
              className='channels'
              id='cai'
              onClick={() => {
                props.history.push('/main');
              }}>
              <div className='settins-profile-img'>
                <img
                  src={
                    'https://image.freepik.com/free-vector/profile-beautiful-smiling-young-woman-with-flower-her-hair_102172-291.jpg'
                  }
                  alt='cai'
                />
              </div>
              <div className='settings-profile-des'>
                <span className='settings-profile-name'>Cai</span>
                <span className='settings-profile-id'>@theofficalcai</span>
              </div>
            </div>
            {/* <hr
          color='grey'
          style={{
            width: '100%',
          }}
        /> */}
            <div
              className='channels'
              id='global'
              onClick={() => {
                props.history.push('/global');
              }}>
              <div className='settins-profile-img'>
                <img
                  src={
                    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQPNLWq9JE_fyvm7iWc90eWEyb7afeWEP8aQ&usqp=CAU'
                  }
                  alt='cai'
                />
              </div>
              <div className='settings-profile-des'>
                <span className='settings-profile-name'>Global</span>
                <span className='settings-profile-id'>@global</span>
              </div>
            </div>
          </div>
          <div className='settings-options'>
            {Options.map((i) => {
              return (
                <div key={i.name} onClick={i.func} className='options'>
                  <span>{i.name}</span>
                  {i.icon}
                </div>
              );
            })}
          </div>
          <CustomDialog
            open={open}
            onSubmit={onSubmit}
            handleClose={handleClose}
            MainText={'Are You Sure?'}
            AgreeText='Logout'
            CloseText='Cancel'
          />
        </>
      ) : (
        <div className='settings-options'>
          <div
            onClick={() => {
              window.location.href = '/register';
            }}
            className='options'>
            <span>Sign In</span>
            <ArrowForwardIosIcon />
          </div>
        </div>
      )}
    </div>
  );
};

export default Settings;
